<template>
  <div class="file-container">
    <div class="main">
      <div class="top-icon-title">
        <img :src="require('@/assets/images/system/top-icon2x.png')" alt="" class="top-icon" />
        <img
          :src="require('@/assets/images/system/top-title2x.png')"
          alt="" class="top-title" />
      </div>
      <div class="file-list" v-loading="fileLoading">
        <el-row class="header">
          <el-col :span="15"
                  style="border-right: 1px solid rgba(225,225,225,0.9)"
          >文件管理</el-col>
          <el-col :span="9">操作</el-col>
        </el-row>
        <empty-view v-if="!totalElements"></empty-view>
        <div v-else>
          <el-row
            v-for="(item, index) in fileData"
            :key="index"
            class="flex justify-between file-item"
          >
            <el-col :span="15" style="padding: 16px 16px 16px 40px;border-right: 1px solid #EEEEEE" >
              <div class="flex items-center">
                <div>
                  <img class="file-icon" v-if="item.suffix === 'excel'" :src="excelBase64" alt="" />
                  <img class="file-icon" v-else-if="item.suffix === 'xlsx'" :src="excelBase64" alt="" />
                  <img class="file-icon" v-else-if="item.suffix === 'pdf'" :src="pdfBase64" alt="" />
                  <img class="file-icon" v-else-if="item.suffix === 'word' || item.suffix === 'docx'" :src="wordBase64" alt="" />
                  <img class="file-icon" v-else-if="item.suffix === 'zip'" :src="zipBase64" alt="" />
                </div>
                <div>
                  <div class="item-name overflow overflow-2" :title="item.fileName">{{ item.fileName }}</div>
                  <div class="item-time" v-if="item.createDate && item.createDate !== 'null' && item.createDate !== 'undefined'">{{ item.createDate ? formatToDateTime(item.createDate) : '-' }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="9" class="flex items-center justify-center" style="padding: 16px;">
              <!-- 0: 重新生成 -->
              <div class="flex items-center pointer btn-style" v-if="item.status === '0'">
                <div class="flex items-center pointer" @click="regenerate(item)">
                  <i class="el-icon-refresh-right" style="color: rgba(0, 0, 14, 0.52);font-size: 14px"></i>
                  <div style="margin-left: 6px;margin-right: 40px;color: #999999">重新生成</div>
                </div>
                <el-popconfirm
                  confirm-button-text='确认'
                  cancel-button-text='取消'
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定删除该条数据吗？"
                  popper-class="confirm-delete-popper"
                  @confirm="deleteFile(item.fileId)"
                >
                  <div slot="reference" class="flex items-center pointer">
                    <i class="el-icon-delete" style="color: #999999; font-size: 14px"></i>
                    <div style="margin-left: 6px;color: #999999">删除</div>
                  </div>
                </el-popconfirm>
              </div>
              <!-- 1: 点击下载 -->
              <div class="flex items-center btn-style" v-else-if="item.status === '1'">
                <div
                  class="flex items-center pointer"
                  @click="downloadFile(item.fileId, item.fileType, item.fileName)"
                >
                  <i class="el-icon-download" style="color: #1241C9; font-size: 14px"></i>
                  <div style="margin-left: 6px; margin-right: 40px; color: #1241C9">点击下载</div>
                </div>
                <el-popconfirm
                  confirm-button-text='确认'
                  cancel-button-text='取消'
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定删除该条数据吗？"
                  popper-class="confirm-delete-popper"
                  @confirm="deleteFile(item.fileId)"
                >
                  <div slot="reference" class="flex items-center pointer">
                    <i class="el-icon-delete" style="color: #f56c6c; font-size: 14px"></i>
                    <div style="margin-left: 6px; color: #f56c6c">删除</div>
                  </div>
                </el-popconfirm>
              </div>
              <!-- 2: 生成中 -->
              <div class="flex items-center pointer btn-style" v-else-if="item.status === '2'">
                <div style="cursor: default; color: #999999;"> 生成中...</div>
              </div>
              <!-- 3: 已过期 -->
              <div class="flex items-center pointer btn-style" v-else-if="item.status === '3'">
                <div style="cursor: default; color: #999999">已过期</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="page-container">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          :current-page="pageNum"
          :hide-on-single-page="true"
          layout="sizes, prev, pager, next"
          :total="totalElements"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { downLoadFileApi, fileDeleteApi, getFileListApi, isReadApi } from '@/api/fileManagement';
import { getCiteReportApi, getScholarReportApi } from "@/api/talent";
import emptyView from "@/components/emptyView.vue";
import { formatToDateTime } from "@/utils/dateUtil";
import { handleExport } from '@/utils/exportFn';

export default {
  name: 'fileManagement',
  components: { emptyView },
  data() {
    return {
      totalElements: 0,
      pageNum: 1,
      pageSize: 10,
      fileData: [],
      //excel图标
      excelBase64:
        'data:image/png;base64,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',
      //pdf图标
      pdfBase64:
        'data:image/png;base64,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',
      //word图标
      wordBase64:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABYCAYAAABrqdC6AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAVKADAAQAAAABAAAAWAAAAABymCBBAAAQD0lEQVR4Ae1dCXBU5R3/v80euQjhktNwhEOlgheK11i1oyKgIKg4atV6tXY6Vqeto3Zs661TtR3Pqu0oKlqtCh7VzrSDY1UoIAlaCArIFZIQQkjYK9lk9/X3e19e8nbzdt/SbEKSzX+yu++97/9dv+9/ff/3dqNJmlRX1/hTXfQFYB+HlxuvWJpVu43N43Hre6r3Fe470FhXVJj/3AnHTn2u2zpLs2EtHb66uoMP6BK7Kx3enuTxejyyfXeVVNXul7xcnxQU5L588syjr+3JMST25Uq8kHheW984pzeCaY5T0zRx5+QYp4FA+JovyzcvNcsOx6cjoDm6dvHhGNih9ukCsHw1BkJXrynf9Mqh1s8UvyOgMYkVZaqz7m6H0upyaRIINF21pqzi1e7uz659R0AFnsiuYm+91g5qKHzl2vKK13t6nM6Ait6nACWABqiQVn8gvOQ/ZRXLehLUNADtyeFkri9TUoOh8BU9Kan9FlAujVVS16zvGfXv14C2g0pHFQovWbuh4s3M6YB9S/0eUCuosKmXrivb/Fd7KDJzNSsAbQeVjioYugyOqtskNWsANUHVoP6hUPhSgPpWZmQyvpWsArQdVEhqMBhe3B2gZh2gJqjcUQWDocXw/n+Ll7GunWUloB2guiQQDi/KJKhZC2g7qFD/NlDf7ppsqtpZDagV1GA4fAkSKu90FdSsB9QElbuqQDC0cG3Z5ne7AuoAoG3oqb2/S/yh0IKuSOoAoBZxNPf+2KYuBKgrLEVpHw4AmgCVCSqyVBetWb/xvYRix9M+D6jeDelagspXINw8HyHVIUlqnwfU5eqeKVgldXXZpuWOotnG0D2jSbf3LvPpkuvzdbmVZA0Ykqr2/hdv+HrLncn4rNf7NKCt0ZgMGVwo+Xk+CTc1W+eVsWOCKjqyVOHw7zZu3D7KqWE+AdJnKRaLiceTI5NKxsquPTVIzYUxF11gATM6J95Ua2pu8eyNNpTisCZV430aUE6spSVqSOiUieOk0R+UpqaIcVuRgpUxYltAVZeoY6t9HlCC1tLSatyPH1Y82Jh5d92mdWlQCQfqF4ByjrGYLpFYi8N0u1Yc05xdjjNH18aQdbUHAM3wkg8AOgBohhHIcHMDEjoAaIYRSLM55mAG5TkzO0pofp7WHI06N9TfOZiDqamPBp3m6Qjouo364MFFjhsEp376dLkbT5wPKhD51WORkU4TSQ3o8KobNn0XnZ+b69RM/y/HVlb3h7RnZHr1MalmmxTQ0jk1N/rGay8U5mveVA1kSxlsaGterl6aXyArp87dOynZvG0BLb1w781I2DyfrFJ2Xme6RduHuR8R1WNfTDuvZqIdDp0ALZ279ybkVQ77F6jsBnuYr9GReNQYtJGtbm2VnaTGATp5bs31yH396TAPvDd3b0km6SOjuqwcN2/3WOuA2wGlZMJOvGgtHDiOQ0BDKGoB1Cgr8cVyPpt47t52728wTL6g+hY9Fns6rjpOmBLz5jC7qEuep7uyjIm99r5zN1DyekXLEd1HTJhsVsRj1wR8lW/9tCXrZ33zxglV7tILaq+N6VGCGca9k7gbM2gg1tSiFYq4vMGIY27V7KXffbqxsdHxNT3cwvJDpVv0hMSoS4uOESn6Z+74mrnajNsiYKc0SyARiVa4s5HDXYVDijRPpHtzt4ld965zuCPc/JTq2hie09Uj7pyETDPg8xS4BjdsynnK7Sn2tGL0jDV5/yCOfFiOPX6RrXVosN3axrFkzQn38sVFroKCQimwuxGiQyyHniiaW49IM3htg3cqeQECBb4GCAgAkNam5Ei0BKUly+UuOTj/b0liGBDXDvcGzbCdrVgZRrUm+SCxOVwKiHYTDAaMtVFOQ5xrluHYqEsLbals1qUKkViGm5YSiqAt9MW2fBhVLnQmHy+Wm7wmP7Nf7NfSrNGW+UZ7RxOFW/a2xHEhhrSt70Hf7i6IWVJAOV+2W4jECG59S2sbMJwEB8tJMoLg4Dl5DpDHBIRAs4ygE0Czbl6bYQkDPA46AlCqG1QfRw4TmTBcZAiyOt9hg1dZD/t9QIE6DHEG+8Of8UaXQLCNCMa4yIIO8DleLpAfzz1wvCPwBXUuNPm5QDxmNWOsrAgyF64xhHpQa2aYCvCUT3F+R5niTP2eFFBWq2kUuWOeyPwTlBSxUw7iZ0tFKqoQKADs318pcvRolOM6Afw1vlL16TcK3PsXi5x1tAKOdQnez19VbXDQlJTFJ4tcdYbIzCMVsOZwd8IRfvyVyMufiWzDsxpjhqo22cb5x4rcs1BpjkJZ1TJBaW6T+D1YlM+/FVn+JfrCNQKE5yDk0SUix6I/LrRJFAYCvu+gSD2ynmU7Rf61Uc2TC5qPunbOyKxvfiYFFO0bKtiAxik5VqI0fYaBTsDnnBnWEpHvYaAflCkAzkGiaxx4TNoOyeMkKfUE86lrRBacaJbGf45HnzefI3L5bCzCKyIr1otMOkKNiVIzcUQ8v+3ZJJGFJ4ksmiVy3QsiB9skduqo5PWnoIw073j0e77Inz8Vefh9dY0aZjU/6mr8O2QqOXHin29VKm/lmoyNVrhJpLStc2sZgaB9G1MMdcHKWumTCiWtAWwfnr0uOZjWOgTvpZtFzoNU0gTQLtJUHAqdOkXkx1ic+oCq1Qhg0yHe8iCo9y4SqfOnJ6GOgO6AVH1THd/9+GE4h+pMAbCJNA3qz0mPg4oW+jpKubJf7xbhZC7C6s/Hy0oc8P0rRK54RmQp1DyRHr4cKgsJCUOy7egjmIe731LStLKiMwdBpYTRwSbSPvT96Acij7wv8mF5YqnITWeLzJoksr9tQTpzdFxJqvJk8QKYvY0iG3ZBlcd1VKKEurF6VMFEmggJHQypGg0JtdLWvWphhhaI/PBMa4myqTf9ReTdtaiL8jdXK/v2o7M6+Kjic7EIT/6945r16O01UM/lsLNYyBgWe9mtWJxTOzgYQWBNbYl287fvKDtLh/sIFu/2OfGsNB1rtimVp61ORikl1KiEUZTvjK8+cjDABKhU70QaNkiBWUIpthAXhZ6b9veYMZYCHH65Q2T1FpHpWLTJWCR65TcAKr21laaPxRnAspvPUJiXApggjmkS2ucYrbQNCxoI24dEXogVhYS2dRTqvfYFNClkra3KGbEkWxSTO6WEkone7b+VygPSE5I4+JklsJND1PkBOK4GDMB0FCeXxjsjctFrhmB3J0HSWN9K67YrZ8OJ0dMOgYTXQmr4GtvWB/lLMWkX7Lqd2t5yrshlpyitmoA+iqBBJm2vhfR+IsLFTiVd5KffoI2uhRmgpplEoNkm+6bmJiNHQGkHOSCGSYaEoKVc1GLoMgzqSaL00WGYgJ5CQC1AkIf2Ez/+JUyFJRLjUgJpEtWOIU2i8zEC/TbQTV7zkyDylUhfQPJvXYp8BOZAE5UoeYn8FEEKjl1wb3h4yzg71cUFDD01cedQFxD5CqCZxKCX9owBPYlOa+Umdcx3Am9VuW2YDFVuBCSETo6hmJWOgiMzA29eDyEKoHSQ30pb0AbvjCfbAVl5zeNjMJbHrxKZBnXmPOzMhclL6eXiDoKUMkqxEmNyP8bFuaciR0C5WlwZqqxJ7JgqYE6M0rlxj1mqVNOq1pRgelKqEx3Arv0dvDyaPVlkOMCraVAqRVtLr0p+K22twVmSEdPm3v6aihToPExi2HXmNJEbvq8Wkju6ROL8AjBHdRjbTiw+QzTaSyvtxpjSSWEmGZ61KbViGyuVN44vUWeVAKgaoJpxHj051dOksh2qLqWQtpY7ECtxJ3L3AiWlBPUH00XuvMjKoTww41hfm5mJLxWhaj/xnsiDK0Qu+aMyMVae4yaoeVh3R2Y5zQ0FoAQO7Z5FeKBhnlnS8flRuZJO0490lMQfQaGdiVs2hj18Mc60Ej3xTqwegeIe3CqZJh/tZwGkDYItxQBk2Srsgs6NB/2K2SKnlopUAVBKpyn9ZhtvoA61INnzRZTEIwDIaGgO2+DWldtLk7jAjEOp0onEiOTDX6ixJ/ZL3k83i3yCF7XIidKSUHpfSl/5rs7NVUEy90Od6f2+re5czoltgarSuVHb6MFZ5+pn1VbQWoNO5bQpncF8v0zkvncBWJHitvPUXCwShiEcr5ENM66oN0oh9/Osm1ifQNPm24HJXABj5DxoVyrvbnaVFqAUcw5ow06zWsfnDgBGNWXKjRKaSJuqsDmAbWI5ifZqVDFWHOp78RPY95er63bvbI8B9y0vqf7pLJicsZs4wzuWcax0aok7Km5MGOMGYStpYpyIzvO+5cgBPK/ao+ZZIxG7+i58o0c7/m4dyip5dgzWa0xmUOTPPEo1rGPwtIlUQ0YADHXoGU+bqkIeSiPLy3aIbAIPVdUIO9oapQRxF0apOQttMinB3RXrcAF2wy7TuTChwliUUkTAmJYrGQrzMAVOAuYG+BkSyc3HZmgIVZsOZkaJeoUBLqkImrEKdpYx9YUzFajWsIwpQdpXhlVMolCrGJ3Q+dI5sm8nwvyeJqCUK1if1EQAghgcQeAk+MZ0Vnt4g3MOhF7cVCmWM7/JgNrOGZCPyWKmywgCF4H9kJfA0i7S9rKAZSSGLeRlGGM6CPbDxaZ9Zl1KMHMDbNdUffJwwQqxsFwsbkXN+kbD6IDjYfuMQSnxRpRh6dvgS/12r3bcXfpqNHRKar6eKTVAa5tYz/SY8V5muXEH9DZI27/RNNYmnrhi9OIUdxxmPVHyKdXGwndG48WyB7R1rrKHtFV4OOQ48H0IHiiJIqoKQwwaeFNtzLKs+ySIQJF3GWzA3Alpewxg3khc4gTvxDv0Et0tYwBgFLk/HYni6KOXhh6cWdJ6wcEgEM5SoqYOytPlDx/nXv96mad82gjs1/C9XXxJORzwS8XWJzueuIkD1A4vXd//vLQCfah9VpNXl+bmnMm5ucXbUuHQFh0mZzmw35XfiqXgKmUz0Y+MLIyOBAYpAXXU45a+7XUzJgP0I7V+xHIO5AhoXKzm0Fi/L3bUZ0QB/R6EHp7gAKAZBtwRUJfGXfoA0Sl78I8cnJBwZIhGu/lnEpxG2AvK+aMwfBS8uTmCrU5qcgTUHwrX5fC/wVhTRanb7HelbmRMWpB1qaysZWYuJTkCWlvX6OHPoXm9ziFDyp76aCF/twn/CIs/hSl1wYBjmtMxEPAH/CN2VFbLhHGjG30+bx4kFRnHbCF8wVP0YF19A56v31/gc7mRUExNjoACRK2+4SAeDouEhxUXtXg9bi8kNoJ431G6U3fdu0vx8+wxPabn+oNN/gONjUO4UfR6c5B7S02OgOpazi5qeyQSGVVZjRQ2EgIqFdu/AQVsMWhjHvbchR7YUONHC93uXanhRHLaiUGPHlymuQp/ScdkOKc0bpc4tdnnymFH9VjrP844aaYjoI5qe/bpp5dDxX/T50DI6IC1erj5n6TTZNo5pJWrNyxx6fw3lNoMRGVIZmmO9iSdAfRiHg/UvQbCtFrXtMfPnj2zMp2x/g+VEVO9rudLsAAAAABJRU5ErkJggg==',
      //zip图标
      zipBase64:
        'data:image/png;base64,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',

      fileLoading: false,
    }
  },
  created() {
    this.getIsRead();
    this.getFileList();
  },
  methods: {
    formatToDateTime,

    // 是否已读
    getIsRead() {
      isReadApi();
    },

    // 重新生成报告
    regenerate(item) {
      //人才清单
      // if (item.fileType === '1'){
      //   // 调用生成excel接口
      //   let params = {
      //     fileId:item.fileId
      //   }
      //   exportCheckedTalentsApi(params).then( res => {
      //     if (res.code === 200){
      //       this.$message.success('文件生成中!');
      //       item.status = '2';
      //     }
      //   })
      // }else

      if (item.fileType === '2') { // 人才报告
        let params = {
          id: item.scholarId,
          fileId: item.fileId
        };
        getScholarReportApi(params).then(res => {
          if (res.code === 200) {
            this.$message.success('文件生成中，请稍后刷新查看！');
            item.status = '2';
          }
        });
      } else if (item.fileType === '3') { // 引文报告
        let params = {
          id: item.scholarId,
          fileId: item.fileId
        };
        getCiteReportApi(params).then(res => {
          if (res.code === 200) {
            this.$message.success('文件生成中，请稍后刷新查看！');
            item.status = '2';
          }
        });
      }
    },

    // 删除文件记录
    deleteFile(fileId) {
      fileDeleteApi({ id: fileId }).then((res) => {
        this.$message.success(res.message);
        if (this.fileData?.length === 1 && this.pageNum !== 1) {
          this.pageNum = this.pageNum -1;
        }
        this.getFileList();
      });
    },

    // 下载文件
    async downloadFile(id, type, name) {
      let pa = {
        id: id,
        type: type
      }

      try {
        const response = await downLoadFileApi(pa);
        handleExport(response, name || '');
      } catch (error) {
        console.log(error);
        throw error;
      }
    },

    // 获取文件列表
    getFileList() {
      this.fileLoading = true;

      let pa = {
        pageNum: this.pageNum - 1,
        pageSize: this.pageSize
      };
      getFileListApi(pa)
        .then((res) => {
          if (res.code === 200) {
            this.totalElements = res.data.totalElements;
            this.fileData = res.data.content;
          }
        })
        .finally(() => {
          this.fileLoading = false;
        });
    },

    // 改变页数
    handleCurrentChange(item) {
      this.pageNum = item;
      this.getFileList();
    },

    // 切换 pageSize
    handleSizeChange(current) {
      this.pageSize = current;
      this.pageNum = 0;
      this.getFileList();
    }
  },
}
</script>

<style lang="less" scoped>
.file-container {
  padding: 12px;
  width: 1400px;
  margin: 0 auto;

  .top-icon-title {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding-top: 60px;
    padding-bottom: 30px;
    .top-icon {
      width: 38px;
      height: 33px;
      margin-right: 10px;
    }
    .top-title {
      height: 29px;
    }
  }

  .file-list {
    width: 90%;
    margin: 0 auto;
    border-radius: 12px;
    border: 1px solid #EBEEF5;

    .header {
      border-radius: 12px 12px 0 0;
      background: #EFF2F5;
      div {
        font-weight: 500;
        text-align: center;
        line-height: 50px;
        font-size: 16px;
        color: #000000;
        border-bottom: 1px solid #EBEEF5;
      }
    }
  }

  .main {
    min-height: calc(100vh - 30px);
    border-radius: 16px;
    background: #ffffff;
  }

  .file-item {
    &:not(:last-child) {
      border-bottom: 1px solid #eeeeee;
    }
    .btn-style {
      font-size: 14px;
      user-select: none;
    }
  }

  .file-icon {
    width: 42px;
    height: 44px;
    color: #999999;
    margin-right: 20px;
  }

  .item-name {
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    cursor: default;
  }

  .item-time {
    display: flex;
    font-size: 13px;
    color: rgba(153, 153, 153, 0.7);
    margin-top: 10px;
    cursor: default;
  }

}
.page-container {
  text-align: center;
  padding: 26px 0;

  /deep/ .el-input__inner {
    height: 36px;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1241C9;
    color: #ffffff;
    font-size: 14px !important;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    border-radius: 4px;
    background-color: #ffffff;
    min-width: 36px;
    height: 36px;
    color: #333333;
    font-size: 14px !important;
    line-height: 36px;
  }
  /deep/ .el-pagination.is-background {
    .btn-next {
      height: 36px;
      line-height: 36px;
      border-radius: 4px;
      background-color: #ffffff;
      .el-icon-arrow-right:before {
        content: '\e791';
      }
    }

    .btn-prev {
      height: 36px;
      line-height: 36px;
      border-radius: 4px;
      background-color: #ffffff;
      .el-icon-arrow-left:before {
        content: '\e792';
      }
    }
  }
}
</style>
